import React, { useRef } from "react";
import PhoneField from "../../UI/phoneInput";
import ArrowTop from "../../Common/svg/arrowtop";

const UserEdit = ({ userInfo, setUserInfo, formErrors }) => {
  const avatarRef = useRef(null);

  const handlePhoneChange = ({ phone, phone_code }) => {
    setUserInfo((prev) => ({
      ...prev,
      phone,
      phone_code,
    }));
  };

  const handleChange = (key, value) => {
    setUserInfo((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div className="row">
      <h5 className="mb-4">تعديل بيانات العميل</h5>

      {/* first name */}
      <div className="col-md-6 mb-3">
        <label className="form-label">الاسم الأول</label>

        <input
          type="text"
          className={`form-control ${
            formErrors?.first_name ? "is-invalid" : ""
          }`}
          value={userInfo.first_name}
          onChange={(e) => handleChange("first_name", e.target.value)}
        />

        {formErrors?.first_name && (
          <small className="invalid-feedback">{formErrors.first_name}</small>
        )}
      </div>

      {/* last name */}
      <div className="col-md-6 mb-3">
        <label className="form-label">الاسم الأخير</label>

        <input
          type="text"
          className={`form-control ${
            formErrors?.last_name ? "is-invalid" : ""
          }`}
          value={userInfo.last_name}
          onChange={(e) => handleChange("last_name", e.target.value)}
        />

        {formErrors?.last_name && (
          <small className="invalid-feedback">{formErrors.last_name}</small>
        )}
      </div>

      {/* phone */}
      <div className="col-12 mb-3">
        {/* <label className="form-label">رقم الهاتف</label> */}

        <PhoneField
          phone={userInfo.phone}
          phone_code={userInfo.phone_code}
          onChange={handlePhoneChange}
        />

        {formErrors?.phone && (
          <small className="invalid-feedback d-block">{formErrors.phone}</small>
        )}
      </div>

      {/* email */}
      <div className="col-md-6 mb-3">
        <label className="form-label">البريد الإلكتروني</label>

        <input
          type="email"
          className={`form-control ${formErrors?.email ? "is-invalid" : ""}`}
          value={userInfo.email}
          onChange={(e) => handleChange("email", e.target.value)}
        />

        {formErrors?.email && (
          <small className="invalid-feedback">{formErrors.email}</small>
        )}
      </div>

      {/* status */}
      <div className="col-md-6 mb-3">
        <label className="form-label">الحالة</label>

        <select
          className="form-select"
          value={userInfo.status}
          onChange={(e) => handleChange("status", e.target.value)}
        >
          <option value="active">نشط</option>
          <option value="inactive">غير نشط</option>
          <option value="blocked">محظور</option>
        </select>
      </div>

      {/* balance */}
      <div className="col-md-6 mb-3">
        <label className="form-label">
          الرصيد
        </label>

        <input
          type="number"
          step="0.01"
          min="0"
          className="form-control"
          value={userInfo.balance}
          onChange={(e) => handleChange("balance", e.target.value)}
        />
      </div>

      {/* loyalty points */}
      {/* <div className="col-md-6 mb-3">
        <label className="form-label">نقاط الولاء</label>

        <input
          type="number"
          className="form-control"
          value={userInfo.loyalty_points}
          onChange={(e) =>
            handleChange(
              "loyalty_points",
              e.target.value
            )
          }
        />
      </div> */}

      {/* available loyalty points */}
      {/* <div className="col-md-6 mb-3">
        <label className="form-label">
          نقاط الولاء المتاحة
        </label>

        <input
          type="number"
          className="form-control"
          value={userInfo.available_loyalty_points}
          onChange={(e) =>
            handleChange(
              "available_loyalty_points",
              e.target.value
            )
          }
        />
      </div> */}

      {/* expire date */}
      {/* <div className="col-md-6 mb-3">
        <label className="form-label">
          تاريخ انتهاء النقاط
        </label>

        <input
          type="datetime-local"
          className="form-control"
          value={
            userInfo.points_expire_at
              ? userInfo.points_expire_at.slice(0, 16)
              : ""
          }
          onChange={(e) =>
            handleChange(
              "points_expire_at",
              e.target.value
            )
          }
        />
      </div> */}

      {/* order count */}
      {/* <div className="col-md-6 mb-3">
        <label className="form-label">عدد الطلبات</label>

        <input
          type="number"
          className="form-control"
          value={userInfo.order_count}
          onChange={(e) =>
            handleChange("order_count", e.target.value)
          }
        />
      </div> */}

      {/* avatar */}
      <div className="col-12 mt-4">
        <label className="form-label">الصورة الشخصية</label>

        <div
          className="border rounded-4 p-4 text-center"
          style={{ cursor: "pointer" }}
          onClick={() => avatarRef.current.click()}
        >
          <ArrowTop />

          <h6 className="mt-2">اضغط لرفع الصورة الشخصية</h6>

          <input
            hidden
            type="file"
            ref={avatarRef}
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];

              handleChange("avatar", file);
            }}
          />

          {userInfo.avatar && (
            <div className="mt-3">
              <img
                src={
                  userInfo.avatar instanceof File
                    ? URL.createObjectURL(userInfo.avatar)
                    : userInfo.avatar
                }
                alt=""
                width={90}
                height={90}
                className="rounded-circle object-fit-cover"
              />
            </div>
          )}
        </div>

        {formErrors?.avatar && (
          <small className="invalid-feedback d-block">
            {formErrors.avatar}
          </small>
        )}
      </div>
    </div>
  );
};

export default UserEdit;
